import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import {
  ContentContainer,
  ModalTitle,
  ButtonsContainer,
} from "./EditNoteModal.styled";
import { TextInput } from "../../TextInput";
import { useTranslation } from "react-i18next";

interface EditNoteModalContentProps {
  note: string;
  onSave: (note: string) => void | Promise<void>;
  onClose: () => void;
}

const EditNoteModalContent: React.FC<EditNoteModalContentProps> = ({
  note,
  onSave,
  onClose,
}) => {
  const { t } = useTranslation();
  const [editedNote, setEditedNote] = useState(note);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    try {
      setIsSaving(true);
      await onSave(editedNote);
      onClose();
    } catch (error) {
      console.error("Error saving note:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ContentContainer>
      <ModalTitle>{t("editNoteModal.title")}</ModalTitle>

      <TextInput
        label={t("editNoteModal.label")}
        fullWidth
        value={editedNote}
        onChange={(
          e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
        ) => setEditedNote(e.target.value)}
        placeholder={t("editNoteModal.placeholder")}
        disabled={isSaving}
      />

      <ButtonsContainer>
        <Button variant="outlined" onClick={onClose} disabled={isSaving}>
          {t("editNoteModal.cancelButton")}
        </Button>
        <Button variant="contained" onClick={handleSave} disabled={isSaving}>
          {isSaving ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            t("editNoteModal.saveButton")
          )}
        </Button>
      </ButtonsContainer>
    </ContentContainer>
  );
};

export default EditNoteModalContent;
